<template>
  <div class="bg-gray-100 pt-16 lg:pt-0">
    <div
        class="fixed z-100 bg-gray-100 inset-x-0 top-0 border-b-2 border-gray-200 lg:border-b-0 lg:static flex items-center">
      <div class="w-full max-w-screen-xl relative mx-auto px-6">
        <div class="lg:border-b-2 lg:border-gray-200 h-16 flex flex-col justify-center">
          <div class="flex items-center -mx-6">
            <div class="lg:w-1/4 xl:w-1/5 pl-6 flex items-center">
              <a href="/" class="flex lg:mr-4">
                <img class="md:mt-4 hidden mt-1 mr-1 h-6 w-auto"
                     :src="require('@/assets/img/logos/logo.png')"
                     alt="Brandfi logo"/>
                <h2 class="text-3xl sm:text-4xl text-teal-600 md:text-5xl font-bold xl:text-4xl font-light leading-tight">
                  Mashariki BroadBand
                </h2> 
              </a>
            </div>
            <div class="flex flex-grow lg:w-3/4 xl:w-4/5">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="w-full max-w-screen-xl relative mx-auto pt-8 pb-24 md:pb-24">
      <div class="xl:flex">
        <div class="hidden md:block xl:w-3/4 text-left md:text-center xl:text-left max-w-2xl md:max-w-3xl ">
          <!-- <h1 class="text-3xl sm:text-4xl md:text-5xl xl:text-4xl font-light leading-tight">BRAND-fi <span
              class="sm:block text-teal-500 font-normal">Connected Digital Experience.</span>
          </h1> -->
          <!-- <p class="mt-6 leading-relaxed sm:text-lg md:text-xl xl:text-lg text-gray-600">
            Subscription-based, Engaging cloud-delivered ,Wi-Fi connect,
            Analytics and Digital Signage solutions
          </p> -->
          <div class="flex mt-6 justify-start md:justify-center xl:justify-start">
            <!-- <a href="/docs/installation"
               class="rounded-lg px-4 md:px-5 xl:px-4 py-3 md:py-4 xl:py-3 bg-teal-500 hover:bg-teal-600 md:text-lg
                       xl:text-base text-white font-semibold leading-tight shadow-md">Get
              Started</a>
            <a href="#what-is-tailwind"
               class="ml-4 rounded-lg px-4 md:px-5 xl:px-4 py-3 md:py-4 xl:py-3 bg-white hover:bg-gray-200
                        md:text-lg xl:text-base text-gray-800 font-semibold leading-tight shadow-md">Why
              Brandfi?</a> -->
          </div>
        </div>
        <div class="md:mt-12 xl:w-1/4 mx-auto  xl:mt-0 px-6 md:px-0">

          <div class="my-3">
                        <span class="font-bold">
                            Create New Account
                        </span>
            <p class="text-gray-700">It's free to signup and only takes a minute.</p>
          </div>


          <div class="bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-2"
               v-if="errors.length">
            <div v-bind:key="error" v-for="error in errors">{{ error }}</div>
          </div>
          <div class="mt-2">
            <div class="content-start">
              <div class="flex  ">
                <div class="mr-1S">
                  <label class="block text-sm leading-5 font-medium text-gray-700">First Name</label>
                  <input aria-label="First Name" name="firstName" type="text" required
                         v-model="firstName"
                         class="appearance-none rounded-md
                                   relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md
                                    focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
                         placeholder="First Name"/>
                </div>
                <div class="ml-1">
                  <label class="block text-sm leading-5 font-medium text-gray-700">Last Name</label>
                  <input aria-label="Last Name" name="lastName" type="text" required
                         v-model="lastName"
                         class="appearance-none rounded-md
                                   relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md
                                    focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
                         placeholder="Last Name"/>
                </div>
              </div>
              <div class="my-3">
                <label class="block text-sm ">Email
                  Address</label>
                <input aria-label="Email address" name="email" type="email" required
                       v-model="email"
                       class="appearance-none rounded-md
                                   relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900
                                    focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
                       placeholder="Email address"/>
              </div>
              <div class="my-3">
                <label class="block text-sm ">Phone Number</label>
                <input aria-label="Phone Number" type="text" required
                       v-model="phoneNumber"
                       class="appearance-none rounded-md
                                   relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900
                                    focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
                       placeholder="Phone Number"/>
              </div>
              <div class="my-3">
                <label class="block text-sm leading-5 ">Password</label>
                <input aria-label="Password" type="password" required
                       v-model="password"
                       class="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900
                      rounded-b-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
                       placeholder="Password"/>
              </div>
            </div>

            <div class="mt-6">
              <button type="submit" v-on:click="register"
                      class="rounded-lg px-4 md:px-5 xl:px-4 py-3 md:py-3 xl:py-3 bg-teal-500 hover:bg-teal-600 md:text-lg
                       xl:text-base text-white font-semibold leading-tight shadow-md w-full">
                Sign up
              </button>
            </div>
            <div class="mt-3 flex items-center justify-between">
              <div class="text-sm leading-5">
                <router-link :to="{name:'password_forgot'}"
                             class="font-medium  text-teal-600 hover:text-teal-500 focus:outline-none focus:underline transition ease-in-out duration-150">
                  Forgot your password?
                </router-link>
              </div>
              <div class="text-sm leading-5">
                <router-link :to="{name: 'login'}"
                             class="font-medium  text-teal-600 hover:text-teal-500 focus:outline-none focus:underline transition ease-in-out duration-150">
                  Login
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Utils from "@/services/Utils";

export default {
  name: 'Register',
  props: {
    msg: String
  },
  data() {
    return {
      loading: false,
      errors: [],
      firstName: null,
      lastName: null,
      phoneNumber: null,
      email: null,
      password: null
    }
  },
  methods: {
    processError(message) {
      let errors = [];
      for (const err in message) {
        // if (!message.hasOwnProperty(err)) continue;
        errors.push(message[err][0]);
      }
      return errors;
    },
    register: function () {
      this.loading = true;
      this.errors = [];
      if (this.firstName == null || this.firstName === '')
        this.errors.push("First name field is required.");
      if (this.lastName == null || this.lastName === '')
        this.errors.push("Last name field is required.");
      if (this.phoneNumber == null || this.phoneNumber === '')
        this.errors.push("Phone number field is required.");
      if (this.email == null || this.email === '')
        this.errors.push("Email field is required.");
      if (this.password == null || this.password === '')
        this.errors.push("Password field is required.");
      if (this.errors.length > 0) {
        this.loading = false;
        return;
      }

      this.axios.post(process.env.VUE_APP_SERVER_URL + '/api/v1/auth/register', {
        first_name: this.firstName,
        last_name: this.lastName,
        phone_number: this.phoneNumber,
        email: this.email,
        password: this.password,
        login: true
      }).then((result) => {
        console.log(result.data);
        this.$store.dispatch('login', result.data.data);
        this.$router.push(this.$store.getters.getRedirectUrl);
      }).catch((error) => {
        if (error.response != null && error.response.status === 422) {
          this.errors = Utils.processError(error.response.data);
        } else
          this.errors.push("We encountered an issue while processing your request. Please try again");
      }).finally(() => {
        this.loading = false;
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
